import AppContext from 'App/AppContext';
import { createLibraryItemReadActivity } from 'components/Links/Helpers/LinkReadActivityHelper';
import { isBrokeredProvider } from 'models/documentProvider';
import ResourceLink from 'models/resourceLink';
import { LibraryOpenInModal } from 'models/setting';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToExternalUrl } from 'utils/url';
import LinkPreviewModal, { ILinkPreviewModalProps } from './LinkPreviewModal';

export const LinkPreviewModalOrUrl = (props: ILinkPreviewModalProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['translation']);
  const [showLinkInModal, setShowLinkInModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (props.isOpen) {
      loadData(props.link);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.link, props.isOpen]);

  const loadData = async (item: ResourceLink | undefined) => {
    const notificationTimeout = setTimeout(() => {
      appContext.showNotification(t('translation:General.Notifications.OpeningDocument'));
    }, 500);

    try {
      setShowLinkInModal(false);
      if (item === undefined) return;
      setIsLoading(true);
      const libraryOpenInModal = appContext.globalDataCache.settings.get(LibraryOpenInModal) as boolean;
      // a provider item opens in the modal like a virtual one: its content is served through
      // the broker, so there is no url the browser can simply navigate to
      if (item.list.isVirtual || isBrokeredProvider(item.list) || (libraryOpenInModal && !item.list.skipPreview)) {
        setShowLinkInModal(true);
      } else {
        const url = await item.getWebURL(appContext);

        navigateToExternalUrl(url, undefined, '');
        props.onClose();
      }
      void createLibraryItemReadActivity(item, appContext);
    } catch (err) {
      appContext.setError(err);
    } finally {
      setIsLoading(false);
      if (notificationTimeout) {
        clearTimeout(notificationTimeout);
      }
    }
  };

  //
  // Main render
  //
  if (!props.isOpen) return null;
  if (isLoading) return null;
  if (!showLinkInModal) return null;

  return (
    <LinkPreviewModal
      {...props}
      isOpen={showLinkInModal}
      onClose={() => {
        setShowLinkInModal(false);
        props.onClose();
      }}
    />
  );
};
